import { MenuItem } from '@card-software/library';
import { environment } from '@environments/environment';
import { UserManagerAdminGroup } from './models/authorization/enum/user-group.enum';
import { ApprovalPolicyRoles, SignatureRoles, USER_MANAGEMENT_ADMIN_ROLES } from './models/roles/roles.group';

// Each entry shows only to the roles its route allows (#6263), so a delegated user manager sees Users only.
const ADMIN = USER_MANAGEMENT_ADMIN_ROLES;

// Access catalog (#6265), in preview: user admins only, and left out where the feature is off (prod).
const ACCESS_CATALOG_MENU: MenuItem = {
  displayName: 'Access Catalog',
  routerLink: '/access-catalog',
  redirect: true,
  roles: ADMIN,
};

// E-signature pages, still in preview: SignaturePreview role only, and left out where the feature is off (prod).
const SIGNATURE_MENU: MenuItem = {
  displayName: 'Signature',
  routerLink: '',
  redirect: false,
  children: [
    {
      displayName: 'Signing Dashboard',
      routerLink: '/signature/dashboard',
      redirect: true,
      roles: [SignatureRoles.SignaturePreview],
    },
    {
      displayName: 'Session History',
      routerLink: '/signature/history',
      redirect: true,
      roles: [SignatureRoles.SignaturePreview],
    },
  ],
};

export const MENU_ITEMS: MenuItem[] = [
  {
    displayName: 'Users Manager',
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Users',
        routerLink: '/users',
        redirect: true,
        roles: [...ADMIN, UserManagerAdminGroup.UserManagerDelegate],
      },
      {
        displayName: 'User Details',
        routerLink: '/user-details',
        redirect: true,
        roles: ADMIN,
      },
      ...(environment.features.accessCatalog ? [ACCESS_CATALOG_MENU] : []),
    ],
  },
  {
    displayName: 'Approval Policies',
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Approval Policies',
        routerLink: '/approval-policies',
        redirect: true,
        roles: [ApprovalPolicyRoles.ApprovalPolicyViewer, ApprovalPolicyRoles.ApprovalPolicyAdmin],
      },
    ],
  },
  {
    displayName: 'Departments Manager',
    routerLink: '',
    redirect: false,
    children: [
      {
        displayName: 'Departments',
        routerLink: '/departments',
        redirect: true,
        roles: ADMIN,
      },
    ],
  },
  ...(environment.features.signature ? [SIGNATURE_MENU] : []),
];
